import {Component, HostListener, OnInit} from '@angular/core';
import { HttpClient, HttpHeaders, HttpRequest } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ViewportScroller } from '@angular/common';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-vagas-parceiros',
  templateUrl: './vagas-parceiros.component.html',
  styleUrls: ['./vagas-parceiros.component.css']
})
export class VagasParceirosComponent implements OnInit {
  deviceInfo = null;
  loading = true;
  model = {
    left: true,
    middle: false,
    right: false
  };
  inputText = "";
  inputTextCidade = "";
  cliqueVagasMob = false;
  exibeLista = true;
  vagas = [];
  vagasFiltr = [];
  vagasFiltro = [];
  vagasPainel = [];
  empresas = [];
  empresasFiltradas = [];
  filtro;
  palavra;
  empresasFilt = false;
  empresaId;
  regiaoFilt = false;
  regiaoVal;
  vagasFilt = false;
  regioes = [];
  regioesFiltradas = [];
  load = true;
  painelVaga = "painelVaga";
  selectEmp = "p";
  selectEstado = 'p';
  buscar = false;
  busca;
  lista = false;

  constructor(private http: HttpClient, private route: ActivatedRoute, private deviceService: DeviceDetectorService, private scroll: ViewportScroller, private meta: Meta) {
    this.getVagas();
    this.exibePainel();

    // this.meta.updateTag(
    //   { name: 'title', content: 'Reachr - Vagas parceiros'
    // });
    // this.meta.updateTag(
    //   { name: 'description', content: 'Inteligência é ganhar rapidez e eficiência no dia a dia. A Reachr atua em 3 pilares: atração, seleção e gestão.'
    // });
    // this.meta.updateTag(
    //   { name: 'keywords', content: 'Recrutamento, rh, Recrutamento digital, recurso humanos, vagas'
    // });
  }

  list() {
    this.lista = true
  }

  getVagas() {
    let array;
    let headers = new HttpHeaders()
    .set('Content-Type', 'application/json')
    //Request
    let url;
    url = 'https://www.recrutasimples.com.br/api/feed-reachr-bb7e1226';
    console.log('init request')
    this.http.get(url, { headers: headers }).subscribe(data => {
      console.log('finish')
      let res = JSON.parse(JSON.stringify(data));

      this.vagas = res.source.job;

      this.loading = false;
      this.load = false
      console.log('vagas', this.vagas);
      this.filtrarArray();
      this.filtrarArrayEstados();
      this.route.params.subscribe(params => {
        let busca = params.busca;
        if (busca) {
          this.buscar = true;
          this.busca = busca;
          this.filtro = this.busca;
          setTimeout(() => {
            console.log("filtrando..");
            this.filtrar();

          }, 100)

        }
      });
    })
  }
  exibePainel(){
    if(this.deviceService.isMobile()){
      this.cliqueVagasMob = true;
    }
  }
  ngOnInit() {
    // let doc = document.getElementById('fale-conosco-modal');
    // doc.style.display = 'none';
  }
  filtrarEmp() {

    if (this.selectEmp != 'p') {
      console.log(this.selectEmp)
      this.empresaId = this.selectEmp;
      this.empresasFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();

    }
    else {
      this.empresaId = 'p'
      this.filtrarVagas();
    }

  }

  filtrarEst() {

    if (this.selectEstado != 'p') {
      this.regiaoVal = this.selectEstado;
      this.regiaoFilt = false;
      this.vagasFilt = true;
      this.filtrarVagas();
    }
    else {
      this.regiaoVal = 'p'
      this.filtrarVagas();
    }

  }
  filtrarVagas() {
    this.load = true;
    this.vagasFiltr = [];
    let array = this.vagasFiltro;
    let i = 0;
    this.vagas = [];
    if ((this.regiaoVal && this.regiaoVal != "p") && (this.empresaId != 'p' && this.empresaId)) {
      console.log('filtrar por estado e empresa')
      for (i; i < array.length; i++) {
        if (array[i].Part.cidade.UF != undefined) {

          if ((array[i].Part.nome) && (array[i].Empresa.EmpresaId === this.empresaId) && (array[i].Part.cidade.UF === this.regiaoVal)) {
            this.vagas.push(array[i]);
          }
        }

      }
    }
    else if ((this.regiaoVal && this.regiaoVal != "p") && (this.empresaId === 'p' || !this.empresaId)) {
      console.log('filtrar por estado')
      for (i; i < array.length; i++) {
        if (array[i].Part.cidade.UF != undefined) {

          if ((array[i].Part.nome) && (array[i].Part.cidade.UF === this.regiaoVal) ) {
            this.vagas.push(array[i]);
          }
        }

      }
    }
    else if (this.empresaId === 'p' && this.regiaoVal === 'p') {
      console.log('filtrar por empresa')
      this.vagas = this.vagasFiltro
    }
    else {
      console.log('filtrar por empresa')
      for (i; i < array.length; i++) {

        if ((array[i].Part.nome) && (array[i].Empresa.EmpresaId === this.empresaId)) {
          this.vagas.push(array[i]);
        }

      }
    }


    console.log('filtradas', this.vagasFiltr);
    this.load = false
  }



  filtrarArray() {
    let array = [];

    array = this.empresas.filter((value, index, array) =>
      !array.filter((v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index).length);
    this.empresasFiltradas = [];

    this.empresasFiltradas = array;
  }

  filtrarArrayEstados() {
    let array = [];
    array = this.regioes.filter((value, index, array) =>
      !array.filter((v, i) => JSON.stringify(value) == JSON.stringify(v) && i < index).length);
    this.regioesFiltradas = array;
  }

  tirarAcentoFiltro() {
    let palavra = this.filtro;
    var palavraSemAcento = "";
    var caracterComAcento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
    var caracterSemAcento = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";

    for (var i = 0; i < palavra.length; i++) {
      var char = palavra.substr(i, 1);
      var indexAcento = caracterComAcento.indexOf(char);
      if (indexAcento != -1) {
        palavraSemAcento += caracterSemAcento.substr(indexAcento, 1);
      } else {
        palavraSemAcento += char;
      }
    }

    return palavraSemAcento.toLocaleLowerCase()
  }

  tirarAcento() {
    let palavra = this.palavra;
    var palavraSemAcento = "";
    var caracterComAcento = "áàãâäéèêëíìîïóòõôöúùûüçÁÀÃÂÄÉÈÊËÍÌÎÏÓÒÕÖÔÚÙÛÜÇ";
    var caracterSemAcento = "aaaaaeeeeiiiiooooouuuucAAAAAEEEEIIIIOOOOOUUUUC";

    for (var i = 0; i < palavra.length; i++) {
      var char = palavra.substr(i, 1);
      var indexAcento = caracterComAcento.indexOf(char);
      if (indexAcento != -1) {
        palavraSemAcento += caracterSemAcento.substr(indexAcento, 1);
      } else {
        palavraSemAcento += char;
      }
    }

    return palavraSemAcento.toLocaleLowerCase()
  }

  filtrar() {
    if (this.filtro != '') {
      this.filtrar2();
    }
    else {
      this.vagas = this.vagasFiltro;
    }
  }

  filtrar2() {
    let string = this.filtro;
    let array = [];

    array = this.vagasFiltro.filter((el) => {
      this.palavra = el.Part.nome;
      let str = this.tirarAcento();
      let stri = this.tirarAcentoFiltro();
      return str.indexOf(stri) >= 0;
    });

    if (array.length > 0) {
      this.vagas = array;
    }
  }

  abrirVaga(vaga) {
    this.vagasPainel.pop();
    this.vagasPainel.push(vaga);
    if(this.deviceService.isMobile()){
      this.cliqueVagasMob = false;
      this.exibeLista = false;
      this.scroll.scrollToPosition([0,0]);
    }

  }

  backLista(){
    this.cliqueVagasMob = true;
    this.exibeLista = true;
  }

  @HostListener('window:scroll', ['$event']) // for window scroll events
  onScroll(event) {
    if ((window.pageYOffset) && (!this.deviceService.isMobile())){
      this.painelVaga = 'painelVaga sticky';
    }else{
      this.painelVaga = 'painelVaga';
    }
  }

}
